import { initialState } from "../employees.slice";

const resetEmployee = () => {
    return initialState;
}

export default resetEmployee